import { GridLoadRequest, GridLoadRequestKeys, GridLoadResponse } from './load-grid-resource.model';
import { getGridResourceIdBySupportingTableId, GridSearchMode } from '../reporting/grid-resource.model';
import { SupportingTableId } from '../reporting/supporting-table.model';

export enum SupportingTableGridLoadRequestKeys {
  supportingTableId = 'supportingTableId',
  loadOptions = 'loadOptions',
}

export enum SupportingTableGridSearchMode {
  ilike = 'ilike',
  hybrid = 'hybrid',
}

export type SupportingTableGridLoadOptions = Record<string, unknown>;

export interface SupportingTableGridLoadRequest {
  [SupportingTableGridLoadRequestKeys.supportingTableId]: SupportingTableId;
  [SupportingTableGridLoadRequestKeys.loadOptions]: SupportingTableGridLoadOptions;
}

export interface SupportingTableGridLoadResponse<TItem extends Record<string, unknown> = Record<string, unknown>> {
  data: TItem[];
  totalCount?: number;
  summary?: unknown[];
  groupCount?: number;
}

export function mapSupportingTableGridLoadRequestToGridLoadRequest(
  request: SupportingTableGridLoadRequest,
): GridLoadRequest {
  return {
    [GridLoadRequestKeys.resourceId]: getGridResourceIdBySupportingTableId(
      request[SupportingTableGridLoadRequestKeys.supportingTableId],
    ),
    [GridLoadRequestKeys.loadOptions]: request[SupportingTableGridLoadRequestKeys.loadOptions],
  };
}

export function mapGridLoadResponseToSupportingTableGridLoadResponse<TItem extends Record<string, unknown>>(
  response: GridLoadResponse<TItem>,
): SupportingTableGridLoadResponse<TItem> {
  return {
    data: response.data,
    totalCount: response.totalCount,
    summary: response.summary,
    groupCount: response.groupCount,
  };
}

export function mapSupportingTableGridSearchModeToGridSearchMode(mode: SupportingTableGridSearchMode): GridSearchMode {
  switch (mode) {
    case SupportingTableGridSearchMode.ilike:
      return GridSearchMode.ilike;
    case SupportingTableGridSearchMode.hybrid:
      return GridSearchMode.hybrid;
    default:
      return GridSearchMode.ilike;
  }
}
